import { render, staticRenderFns } from "./ModalTable.vue?vue&type=template&id=06b92d19&"
import script from "./ModalTable.vue?vue&type=script&lang=js&"
export * from "./ModalTable.vue?vue&type=script&lang=js&"
import style0 from "./ModalTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports